module.exports = __webpack_public_path__ + "static/media/tocaLogo.3130dcc1.png";